<style lang="scss">
	#warp_subs_from{
		display: flex;
		justify-content: space-between;
		.ant-col{
			margin-bottom: -.5rem;
		}
		.ant-input-disabled{
			color: #000;
			background-color: #fff;
			// border: 0;
		}
	}
	.mycol_div6{
		width: 24%;
		display: inline-block;
	}
	.id_nav{
		display: inline-block;
	}
	.id_nav .mydiv{
		width: 48%;
		margin-top: .5rem;
		display: inline-block;
	}
	#text_title{
		font-size: .8rem;
		color: #000;
		text-align: center;
		vertical-align: bottom;
		border-bottom: 1px solid #d8d8d8;
		border-top: 1px solid #d8d8d8;
		margin-bottom: 1rem;
		padding: .5rem 0;
		display: flex;
		justify-content: space-between;
	}
	#text_title>div{
		width: 24.4%;
		display: inline-block;
	}
	#text_title>div>div{
		width: 45%;
		display: inline-block;
	}
	#warp_sub, #warp_subs {
		.dateinput{
			width: 35% !important;
		}
		.valinput{
			width: 35% !important;
		}
		.warp_rightz {
			.ant-input {
				padding-right: 1rem !important;
			}
		}

		.ant-btn:hover,
		.ant-btn:focus {
			color: #0c8b96 !important;
			background-color: #fff;
			border-color: #0c8b96 !important;
		}



		.ant-input {
			height: 1.8rem;
			font-size: 0.8rem;
		}

		.ant-select-selection--single .ant-select-selection__rendered {
			height: 1.8rem;
			font-size: 0.8rem;
		}

		.ant-select-selection--single {
			height: 1.8rem;
			font-size: 0.8rem;
		}

		.ant-form label {
			font-size: .8rem;
		}

		.warp_button {
			width: 98%;
			margin: 0 auto;
			overflow: hidden;
		}

		.six_div>div{
			display: inline-block;
			margin-right: 2rem;
			font-size: .8rem;
		}
		.six_div{
			width: 70%;
		}
		
		.warp_a{
			width: 1.95rem;
			text-align: center;
			margin: 0;
			display: inline-block;
		}
		
		.texright{
			text-align: right;
			// margin-left: 4%;
		}
		.warp-right {
			float: right;
		}

		.ant-form-item-label {
			width: 15% !important;
		}
		.ant-form-item-control-wrapper{
			width: 85% !important;
			.wart-t{
				width: 100%;
			}
		}
		.warp_long {
			width: 50%;
			display: inline-block;
			
			.ant-form-item-label {
				width: 30% !important;
			}
			.ant-form-item-control-wrapper{
				width: 60% !important;
				
			}
		}
		.formItem{
			.ant-form-item-children{
				display: flex;
				justify-content: space-between;
			}
		}
		.warp_width {
			// width: 9rem;
		}

		.ant-form-item {
			margin-bottom: .6rem;
			width: 100% !important;
			margin-right: 0;
		}

		.qxBtn,
		.qdBtn {
			width: 9rem;
			height: 2.5rem;
			color: #fff;
			/* padding: 0.8rem 4rem; */
			outline: none;
			border: 0;
			border-radius: 5px;
			font-size: 0.8rem;
		}

		.qxBtn {
			background-color: #c8c8c8;
		}

		.qdBtn {
			background-color: #0c8b97;
			margin-left: auto;
		}

		.landen {
			.ant-form-item-label {
				white-space: pre-wrap;
				line-height: .8rem;
				padding: 0.3rem 0;
			}

			.ant-form label {
				font-size: .6rem;
			}
		}
	}

	#warp_sub .ant-form-explain {
		min-height: 0;
		display: none;
	}

	#on-center {
		.ant-form-item-label {
			margin-top: 1.5rem;
		}
	}

	#warp_sub .nonebor {
		position: relative;
		top: 3rem;
		text-align: right;

		div {
			display: inline-block;
			padding: 0 6px;
			cursor: pointer;
		}
	}
	#warp_sub .btnimg{
		border: 1px solid #d8d8d8;
		text-align: center;
		width: 100%;
		margin-right: .5rem;
		display: inline-block;
		height: 1.8rem;
		position: relative;
		top: 0.1rem;
		cursor: pointer;
	}
	#warp_sub .imgbtn{
		width: 1rem;
	}
</style>
<template>
	<div id='warp_subs' style="padding: 20px;">
		<div id='text_title' style='width: 100%;margin: 0 auto .2rem;'>
			<div v-for='i in 4'>
				<div>
					申請認購的
					<br>香港發售<br>
					股份數目
				</div>
				<div>
					<br>
					申請時<br>
					應繳款項
				</div>
			</div>
		</div>
		<div id='warp_subs_from'>
			<div class='mycol_div6' v-for='(v,i) in fouten'>
				<div class='id_nav' v-for='(k,ind) in v' :key='ind+"223366"'
					style='width: 100%;display: flex;justify-content: space-between;'>
					<div class='mydiv'>
						<a-input v-model="k.pricekey" class='warp_width' @input='numarrfn(ind,"pricekey",i,0)'
							:disabled='!ipoAdmin' @pressEnter='servicechange(ind,k.pricekey,i)'
						 @blur='servicechange(ind,k.pricekey,i)'></a-input>
					</div>
					<div class='mydiv'>
						<a-input v-model="k.priceval" class='warp_width' :disabled='!ipoAdmin'
							@blur='numarrfn(ind,"priceval",i,2)' @pressEnter='numarrfn(ind,"priceval",i,2)'></a-input>
					</div>
				</div>
			</div>
		</div>
		<div class='warp_button' style="margin-top: 2rem;display: flex;justify-content: space-between;">
			<div class='six_div'>
				<div>
					公司名稱: {{form.cn_planned_company_name_cn}}
				</div>
				<div>
					招股價:
					<span v-if='form.offer_price_h'>{{form.offer_price_h}}</span>
					<span v-else-if='form.offer_price_l'>{{form.offer_price_l}}</span>
				</div>
				<br>
				<div>
					交易佣金: {{ServiceCharge.commission}}
				</div>
				<div>
					交易微費: {{ServiceCharge.Micro_fee}}
				</div>
				<div>
					交易費: {{ServiceCharge.Transaction_fee}}
				</div>
				<div>
					會財局交易徵費: {{ServiceCharge.Matimp}}
				</div>
			</div>
			<!-- <button type="button" class="qdBtn"  :loading="loading"> -->
				<!-- {{lang.confirm}} -->
				<!-- 確認 -->
			<!-- </button> -->
				<div style="margin-left: auto;display: flex;">
					<button class='btn1 btnx' @click="downClick()">下載</button>
					<button class='btn1 btnx' style="background: rgb(88, 133, 234);" @click='savefn' v-if='!ipoAduitAdmin'>保存</button>
					<button class='btn1 ' style="background-color: #f48d28;" @click='$emit("child","handhome4")'>下一頁</button>
				</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['isopen','forms','missionflag'],
		components: {
			
		},
		data() {
			return {
				ipoAduitAdmin: this.$store.state.rolesdata.indexOf('ipoAduitAdmin') >= 0,
				loading: false,
				ipoAdmin: this.$store.state.rolesdata.indexOf('ipoAdmin') >= 0,
				ServiceCharge: {
					commission: '1%',
					Micro_fee: '0.0027%',
					Transaction_fee: '0.00565%',
					Matimp: '0.00015%',
				},
				fouten: {
					'12': [],
					'24': [],
					'36': [],
					'48': [],
				},
				form: {
					"pricelist":[
					   {"pricekey":"",
					    "priceval":"" 
					   },
					  ],
					stockname_en: '', //股票名稱英文
					cn_planned_company_name_en: '', //公司名稱英文 
					cn_planned_industry_name_en: '', //行業英文 
					"stockcode": "", //輸入股票代碼
					"stockname": "", //輸入股票名稱
					"offer_price_l": '', //招股價起始值
					"offer_price_h": '', //招股價最大值
					"pergshu": '', //每手股數
					"application_open": "", //認購日期起始
					"application_close": "", //認購日期截止
					"listingdate": "", //上市日期
					"entryfee": '', //入場費
					"cn_planned_company_name_cn": "", //公司名稱
					"cn_planned_industry_name_cn": "", //上市行業
					"status_cn": "", //上市狀態   已上市 （股票名称 股票代码）
					"plates_cn": "", //上市板塊
					"delivery_date": "", //遞表日期
					"baojianr": "", //保薦機構
					"anpantime": "", //暗盤時間
					"multiple": '', //認購倍數
					info: '',
					linkaddress:'',
					pricefileid :'',
					loan_ratio :'',	// 比率
					loan_days :'',	// 日數
					gain :'',		// 利息
					// "adminid": "", // 錄入人唯一標識
				},
			}
		},
		created(){
			let _this= this;
			_this.foutenfn()
		},
		mounted() {
			this.form = JSON.parse(JSON.stringify(this.forms))
			let objarr = this.form.pricelist
			for(let key in this.fouten){
				let b=0;
				for(let a=(key-12);a<key*1;a++){
					if(objarr[a]){
						objarr[a]['pricekey'] = this.numgeshihua(objarr[a]['pricekey'],0)
						objarr[a]['priceval'] = this.numgeshihua(objarr[a]['priceval'],2)
						this.fouten[key][b] = objarr[a]
					}
					b++
				}
			}
		},
		methods:{
			downClick(){
				let url = ''
				let _this = this;
				url = _this.$api.exportAmountTable;
				url += '?token=' + _this.$store.state.token
				url += '&iposelling_id=' + _this.forms.iposelling_id
				url += '&missionflag='+ _this.missionflag
				console.log(url);
				window.location.href = url;
			},
			savefn(){
				let numarr = JSON.parse(JSON.stringify(this.fouten))
				let brr=[];
				for(let key in numarr){
					numarr[key].map((val,i)=>{
					if(val['pricekey']){
						val['pricekey'] = val['pricekey'].split(',').join('')
						if(val['priceval']){
							val['priceval'] = val['priceval'].split(',').join('')
								brr.push(val)   
						}
					}
				})
				}
				let objf = JSON.parse(JSON.stringify(this.forms))
				objf.pricelist = brr;
				this.$ajax({
					method:'post',
					url:this.$api.newIpoSellingAudit,
					data:objf
				}).then(res=>{
					if(res.data.qmiscode === 1000){
						this.$message.success(res.data.qmismsg)
						this.$emit('child','save',res.data.id)
					}else{
						this.$message.warning(res.data.qmismsg)
					}
				})
			},
			numgeshihua(ins,c, d, t){
			var n = ins, 
			    c = isNaN(c = Math.abs(c)) ? 2 : c, 
			    d = d == undefined ? "." : d, 
			    t = t == undefined ? "," : t, 
			    s = n < 0 ? "-" : "", 
			    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))), 
			    j = (j = i.length) > 3 ? j % 3 : 0;
			   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
			 },
			servicechange(i,v,key){
				let numv = v.split(',').join('')
				if(v){
					let num = numv *(this.form.offer_price_h||this.form.offer_price_l)*(.01+0.000027+0.0000565+1+.0000015)
					this.$set(this.fouten[key][i],'priceval',this.numgeshihua(num))
				}else{
					this.$set(this.fouten[key][i],'priceval','')
				}
			},
			numarrfn(ind,key,v,end){
				let arr = JSON.parse(JSON.stringify(this.fouten))
				let str = arr[v][ind][key].split(',').join('')
				if(str){
					if(isNaN(str)){
						this.$set(arr[v][ind],key,'')
					}else{
						this.$set(arr[v][ind],key,this.numgeshihua(str,end))
					}
					this.fouten = arr
				}
			},
			foutenfn(){
				for(let key in this.fouten){
					for(let a=0;a<12;a++){
						this.fouten[key].push({
							'pricekey':'',
							'priceval':''
						})
					}
				}
			},
		}
	}
</script>

<style>
</style>
